export function areArraysEqual(a1, a2) {
    if (a1 === undefined || a2 === undefined) {
        return false
    }

    return JSON.stringify(a1) === JSON.stringify(a2)
}

